module.exports = __webpack_public_path__ + "img/HF.ed9bac46.png";